import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

interface TechItem {
  name: string;
  logo: string;
}

const technologies: TechItem[] = [
  { name: "Figma", logo: "https://cdn.simpleicons.org/figma/F24E1E" },
  { name: "Adobe XD", logo: "https://cdn.simpleicons.org/adobexd/FF61F6" },
  { name: "Sketch", logo: "https://cdn.simpleicons.org/sketch/F7B500" },
  { name: "InVision", logo: "https://cdn.simpleicons.org/invision/FF3366" },
  { name: "Framer", logo: "https://cdn.simpleicons.org/framer/0055FF" },
  { name: "Adobe Photoshop", logo: "https://cdn.simpleicons.org/adobephotoshop/31A8FF" },
  { name: "Adobe Illustrator", logo: "https://cdn.simpleicons.org/adobeillustrator/FF9A00" },
  { name: "Zeplin", logo: "https://cdn.simpleicons.org/zeplin/FDBD39" },
  { name: "Miro", logo: "https://cdn.simpleicons.org/miro/050038" },
];

const UiuxTechnologies: React.FC = () => {
  return (
    <section className="wdev-tech" aria-labelledby="uiux-tech-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="uiux-tech-title" className="wdev-section-head__title">
            Design Tools &amp; Technologies
          </h2>
        </AnimatedSection>

        <div className="wdev-tech__grid">
          {technologies.map((tech, index) => (
            <motion.div
              key={tech.name}
              className="wdev-tech-card"
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ y: -4, transition: { duration: 0.2 } }}
            >
              <div className="wdev-tech-card__logo">
                <img src={tech.logo} alt={`${tech.name} logo`} loading="lazy" />
              </div>
              <span className="wdev-tech-card__name">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UiuxTechnologies;
